import {createSlice} from "@reduxjs/toolkit";
import {CommonTableState, updateTableState} from "./general/commonTableSliceFeatures";

type CentreSlice = CommonTableState;

const initialState: CentreSlice = {
    tableState: {
        resetIndicator: 0,
        sorting: [{id: "created", desc: true}],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: ["clientId", "code", "name", "useAsDefault", "valid", "note", "externalId", "created", "mrt-row-actions"],
        density: "compact",
    },
};

export const centreSlice = createSlice({
    name: "centre",
    initialState: initialState,
    reducers: {
        updateCentreTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateCentreTableState} = centreSlice.actions;

export default centreSlice.reducer;
